/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_MetaInputs */

const cs_enum_meta = /** @type {(inputs: Enum_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta`)
};

const en_enum_meta = /** @type {(inputs: Enum_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta`)
};

/**
* | output |
* | --- |
* | "Meta" |
*
* @param {Enum_MetaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_meta = /** @type {((inputs?: Enum_MetaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_MetaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_meta(inputs)
	return cs_enum_meta(inputs)
});